//
//
//
//
//
//
//
//
//

import pkHeader from './common/header/header.vue'
import IO from "socket.io-client";
 export default{
    components:{
        pkHeader
    },
     data(){
        return{
            "socket":"",
        }
     },
    mounted(){
        var map = new BMap.Map("allmap111");    // 创建Map实例*/
        map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);  // 初始化地图,设置中心点坐标和地图级别
        //map.addControl(new BMap.MapTypeControl());   //添加地图类型控件
        map.setCurrentCity("北京");          // 设置地图显示的城市 此项是必须设置的
        //map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放*!/

        this.socket=IO.connect(location.host);
        //定位对方的位置
        this.connectSocket(this.socket,function (mqttMsgObj) {
            console.log("mqttMsgObj",mqttMsgObj);
            /*//模拟经纬度坐标
            switch (mqttMsgObj.op){
                case "00"://位置共享
                    otherPoint=new AMap.LngLat(mqttMsgObj.c.lng,mqttMsgObj.c.lat);break;
                case "99"://结束任务
                case "02"://司机位置未开启
                case "01"://司机端络网
                default:otherPoint=null;break;
            }
            _this.oterPosition(myMap,marker,otherPoint,selfPoint);
            //等待两个坐标都确定后设置其显示的区域
            selfPoint&&otherPoint&&_this.setMapView(myMap,selfPoint,otherPoint)*/
        });
    },
     methods:{
         //建立socket连接获取司机的经纬度
         connectSocket(socket,fun){
             var that =  this;
             socket.on("connect",function () {
                 //连接成功后传输用户token
                 console.log("连接");
                 //发送参数给mqtt
                 socket.emit("transferToken",{token:"4e82ed6d667ddcb68d31edf4656be670",topic:"/car/172221154118729310923157102/172221154175412915270073054/3000000031"||"msg/car2"})
             });
             socket.on("connectError",function (e) {
                 console.log("MQTT连接错误",e)
             });
             socket.on('mqttMsg', function (data) {
                 //司机端返回的消息
                 console.log("data",data);
                 typeof data!="object"&&(data=JSON.parse(data));
                 fun&&fun(data);
             });
         }
     }
 }



// WEBPACK FOOTER //
// ./src/components/carPosition.vue